import React from "react";
import { T } from "../../../app/tokens.js";

// Read-only placeholder. No Slack requests or Signals-specific data loading.
export function ProjectsSignals() {
  return (
    <section
      aria-label="Signals"
      data-testid="projects-signals"
      style={{
        padding: 24,
        border: `1px solid ${T.projectsStripBorder}`,
        borderRadius: 8,
        background: T.projectsStripBg,
        color: T.projectsStripText,
      }}
    >
      <h2 style={{ margin: "0 0 8px", fontSize: T.fsMd5, fontWeight: T.fwBold }}>
        Signals - coming soon
      </h2>
      <p style={{ margin: 0, fontSize: T.fsSm }}>
        Relevant updates picked up from your project Slack channels. Coming soon.
      </p>
    </section>
  );
}
